import dataLayerPush, {
  DataLayerListenerArgs,
} from "@magalu/ecomm-components/rave/events/GA/utils/dataLayerPush";

type SelectItemProps = {
  eventId?: string;
  globalData: DataLayerListenerArgs<unknown>;
  value: {
    content_id?: string;
    content_type?: string;
    screenName?: string;
  };
};

export const selectItem = ({ globalData, value }: SelectItemProps) => {
  return dataLayerPush(() => ({
    content_id: value?.content_id || undefined,
    content_type: value?.content_type || undefined,
    event: "select_content",
    screenName: globalData?.route?.name || undefined,
  }))({ globalData });
};
